export const TRAININGS_SET_CATEGORIES = 'trainings/set-categories';
